var script = {
  name: 'PendoTagGroup',
  props: {
    column: {
      type: Boolean,
      default: true
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-tag-group.vue2.js.map
